module.exports = __webpack_public_path__ + "img/sign_up.7e470dfb.png";